import { __assign, __extends } from "tslib";
import React from 'react';
import omit from 'lodash/omit';
import DaViewer from '../../DaEditor/components/Viewer/Viewer';
import { Image } from '../PluginComponents/Image';
import { Gallery } from '../PluginComponents/Gallery';
import { withMobileContext, ThemeContext, } from '../../Context';
var BaseViewer = /** @class */ (function (_super) {
    __extends(BaseViewer, _super);
    function BaseViewer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseViewer.prototype.render = function () {
        var restProps = omit(this.props, ['fixedParagraph']);
        var _a = this.props.fixedParagraph, fixedParagraph = _a === void 0 ? true : _a;
        var isMobile = this.props.isMobile;
        // Never fixed for mobile
        if (isMobile) {
            fixedParagraph = false;
        }
        return (React.createElement(ThemeContext.Consumer, null, function (contextTheme) { return (React.createElement(DaViewer, __assign({ imageComponent: Image, galleryComponent: Gallery, isDarkTheme: contextTheme === 'dark', fixedParagraph: fixedParagraph }, restProps))); }));
    };
    return BaseViewer;
}(React.Component));
export default withMobileContext(BaseViewer);
//# sourceMappingURL=Base.js.map